// Datos de demostración (FASE 1). La estructura de campos refleja el futuro
// esquema de base de datos: users, family_members, matters, documents,
// reminders.

export const STATUS = {
  ATTENTION: "REQUIERE TU ATENCIÓN",
  UPCOMING: "PRÓXIMAMENTE",
  CONTROLLED: "BAJO CONTROL",
  RESOLVED: "RESUELTO",
  PAST: "PASADO",
  DONE: "HECHO",
};

export const STATUS_STYLES = {
  [STATUS.ATTENTION]: {
    leftBorder: "border-l-[#DC2626]",
    indicator: "#DC2626",
    badgeBg: "bg-[#FEE2E2]",
    badgeText: "text-[#B91C1C]",
    tint: "bg-[#FEF2F2]",
    dot: "bg-[#DC2626]",
    label: "Requiere atención",
  },
  [STATUS.UPCOMING]: {
    leftBorder: "border-l-[#D97706]",
    indicator: "#D97706",
    badgeBg: "bg-[#FEF3C7]",
    badgeText: "text-[#B45309]",
    tint: "bg-[#FFFBEB]",
    dot: "bg-[#D97706]",
    label: "Próximamente",
  },
  [STATUS.CONTROLLED]: {
    leftBorder: "border-l-[#16A34A]",
    indicator: "#16A34A",
    badgeBg: "bg-[#DCFCE7]",
    badgeText: "text-[#15803D]",
    tint: "bg-[#F0FDF4]",
    dot: "bg-[#16A34A]",
    label: "Documentación al día",
  },
  [STATUS.RESOLVED]: {
    leftBorder: "border-l-[#9CA3AF]",
    indicator: "#6B7280",
    badgeBg: "bg-[#E5E7EB]",
    badgeText: "text-[#4B5563]",
    tint: "bg-[#F3F4F6]",
    dot: "bg-[#9CA3AF]",
    label: "Resuelto",
  },
  [STATUS.PAST]: {
    leftBorder: "border-l-[#9CA3AF]",
    indicator: "#6B7280",
    badgeBg: "bg-[#E5E7EB]",
    badgeText: "text-[#4B5563]",
    tint: "bg-[#F3F4F6]",
    dot: "bg-[#9CA3AF]",
    label: "Pasado",
  },
  [STATUS.DONE]: {
    leftBorder: "border-l-[#3A6B56]",
    indicator: "#3A6B56",
    badgeBg: "bg-[#E8F0EC]",
    badgeText: "text-[#2E5645]",
    tint: "bg-[#F0F6F2]",
    dot: "bg-[#3A6B56]",
    label: "Hecho",
  },
};

// Tipos de insight para diferenciar visualmente qué es un dato objetivo,
// qué es una sugerencia del agente y qué conviene que el usuario verifique.
export const INSIGHT = {
  DETECTED: "detected",
  RECOMMENDATION: "recommendation",
  VERIFY: "verify",
};

export const CURRENT_USER = {
  id: "user-demo-1",
  name: "Ángel",
  family_members: [
    { id: "fm-self", name: "Ángel", relation: "Yo mismo" },
    { id: "fm-partner", name: "Carmen", relation: "Pareja" },
    { id: "fm-mother", name: "Madre", relation: "Madre" },
  ],
};

// matters: asuntos gestionados
export const MATTERS = [
  {
    id: "car-insurance",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    title: "Seguro del coche",
    category: "Vehículos",
    matter_type: "Seguro de automóvil",
    status: STATUS.ATTENTION,
    priority: "alta",
    icon: "Car",
    provider: "MAPFRE",
    relatedTo: "Kia Sportage · 1234 KLM",
    summary: "Renovación del seguro del vehículo con subida de prima.",
    due_date: "2026-10-23",
    due_label: "Renovación en 18 días · 23 de octubre de 2026",
    amount: 684,
    previous_amount: 591,
    priceDiff: "+15,7%",
    autoRenew: true,
    insights: [
      { type: "detected", text: "Renovación detectada el 23/10/2026 con una nueva prima de 684 €." },
      { type: "detected", text: "La prima anterior fue de 591 €, un incremento de +93 € (+15,7%)." },
      { type: "recommendation", text: "Conviene revisar la prima antes de la renovación. Puedes pedir ofertas alternativas a tu mediador o negociar las coberturas." },
      { type: "verify", text: "La renovación figura como automática. Comprueba en tu póliza si deseas evitar que se renueve sola." },
    ],
    steps: [
      "Revisar la nueva prima y las coberturas de la póliza.",
      "Solicitar al mediador una revisión o comparar con otras compañías.",
      "Decidir antes del 23/10/2026 si renovar, negociar o cambiar de seguro.",
    ],
    reminders: [
      { date_label: "8 de octubre de 2026", status: "Programado", text: "Primer aviso: revisar la prima" },
      { date_label: "18 de octubre de 2026", status: "Programado", text: "Aviso final antes de la renovación" },
    ],
    history: [
      { date_label: "20 oct 2025", text: "Póliza anterior registrada (591 €)." },
      { date_label: "28 sep 2026", text: "Documento de renovación recibido y analizado por AL DÍA." },
      { date_label: "28 sep 2026", text: "Detectada una subida de prima del 15,7%." },
    ],
    actions: ["Ver opciones", "Preparar correo", "Recordármelo"],
    documents: ["doc-car-policy"],
  },
  {
    id: "digital-cert",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    title: "Certificado digital FNMT",
    category: "Contratos y seguros",
    matter_type: "Certificado",
    status: STATUS.ATTENTION,
    priority: "alta",
    icon: "ShieldCheck",
    provider: "FNMT",
    relatedTo: "Ángel",
    summary: "El certificado digital caduca próximamente.",
    due_date: "2026-11-17",
    due_label: "Caduca el 17 de noviembre de 2026",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Fecha de caducidad del certificado: 17/11/2026." },
      { type: "recommendation", text: "Conviene renovarlo por internet antes de la fecha para no tener que acudir presencialmente a una oficina." },
      { type: "verify", text: "Comprueba que el certificado sea de la FNMT y que tengas acceso al equipo donde está instalado antes de iniciar la renovación." },
    ],
    steps: [
      "Acceder a la sede de la FNMT con el certificado aún en vigor.",
      "Solicitar la renovación online (sin desplazarte).",
      "Descargar e instalar el nuevo certificado.",
    ],
    reminders: [
      { date_label: "3 de noviembre de 2026", status: "Programado", text: "Aviso para iniciar la renovación online" },
    ],
    history: [
      { date_label: "17 nov 2022", text: "Certificado digital emitido (validez 4 años)." },
      { date_label: "1 oct 2026", text: "AL DÍA detecta la próxima caducidad." },
    ],
    actions: ["Cómo renovarlo", "Recordármelo"],
    documents: [],
  },
  {
    id: "home-insurance",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    title: "Seguro del hogar",
    category: "Hogar",
    matter_type: "Seguro de hogar",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Home",
    provider: "Línea Directa",
    relatedTo: "Vivienda habitual",
    summary: "Póliza de hogar al día, renovación automática.",
    due_date: "2027-03-01",
    due_label: "Próxima renovación: 1 de marzo de 2027",
    amount: 312,
    previous_amount: 305,
    insights: [
      { type: "detected", text: "Renovación automática el 01/03/2027 por 312 €." },
      { type: "recommendation", text: "Todo correcto. Te avisaré con antelación antes de la próxima renovación." },
    ],
    steps: ["No se requiere ninguna acción por ahora."],
    reminders: [
      { date_label: "15 de febrero de 2027", status: "Programado", text: "Aviso previo a la renovación" },
    ],
    history: [
      { date_label: "1 mar 2025", text: "Póliza de hogar registrada (305 €)." },
    ],
    actions: ["Ver detalle"],
    documents: ["doc-home-policy"],
  },
  {
    id: "car-itv",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    title: "ITV del vehículo",
    category: "Vehículos",
    matter_type: "ITV",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Car",
    provider: "Estación ITV",
    relatedTo: "Kia Sportage · 1234 KLM",
    summary: "Inspección técnica vigente.",
    due_date: "2027-05-14",
    due_label: "Próxima ITV: 14 de mayo de 2027",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "La ITV está en vigor hasta el 14/05/2027." },
      { type: "recommendation", text: "Sin acciones por ahora. Te avisaré antes de la próxima inspección." },
    ],
    steps: ["No se requiere ninguna acción por ahora."],
    reminders: [
      { date_label: "14 de abril de 2027", status: "Programado", text: "Aviso: pedir cita de ITV" },
    ],
    history: [
      { date_label: "14 may 2025", text: "ITV favorable registrada." },
    ],
    actions: ["Ver detalle"],
    documents: [],
  },
  {
    id: "home-ibi",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    title: "Impuesto de Bienes Inmuebles (IBI)",
    category: "Hogar",
    matter_type: "Impuesto",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Receipt",
    provider: "Ayuntamiento",
    relatedTo: "Vivienda habitual",
    summary: "IBI domiciliado y pagado.",
    due_date: "2026-09-10",
    due_label: "Cobrado por domiciliación el 10 de septiembre de 2026",
    amount: 412,
    previous_amount: 412,
    insights: [
      { type: "detected", text: "IBI de 412 € cobrado por domiciliación el 10/09/2026." },
      { type: "recommendation", text: "Pago correcto. Guardado en tu archivo." },
    ],
    steps: ["No se requiere ninguna acción."],
    reminders: [],
    history: [
      { date_label: "10 sep 2026", text: "Recibo del IBI recibido y archivado." },
    ],
    actions: ["Ver detalle"],
    documents: ["doc-ibi"],
  },
  {
    id: "internet-contract",
    user_id: "user-demo-1",
    family_member_id: "fm-partner",
    person: "Pareja (Carmen)",
    title: "Internet y telefonía",
    category: "Contratos y seguros",
    matter_type: "Suministro / Telecomunicaciones",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Wifi",
    provider: "Movistar",
    relatedTo: "Vivienda habitual",
    summary: "Tarifa de fibra y móvil estable.",
    due_date: "2027-01-20",
    due_label: "Permanencia hasta: 20 de enero de 2027",
    amount: 58,
    previous_amount: 58,
    insights: [
      { type: "detected", text: "Permanencia del contrato hasta el 20/01/2027. Cuota mensual: 58 €." },
      { type: "recommendation", text: "Tarifa estable. Revisaré si hay subidas en la próxima factura." },
    ],
    steps: ["No se requiere ninguna acción por ahora."],
    reminders: [
      { date_label: "6 de enero de 2027", status: "Programado", text: "Aviso: fin de permanencia próximo" },
    ],
    history: [
      { date_label: "20 ene 2025", text: "Contrato de fibra y móvil registrado." },
    ],
    actions: ["Ver detalle"],
    documents: [],
  },
  {
    id: "mother-decesos",
    user_id: "user-demo-1",
    family_member_id: "fm-mother",
    person: "Madre",
    title: "Seguro de decesos",
    category: "Contratos y seguros",
    matter_type: "Seguro",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "ShieldCheck",
    provider: "Santalucía",
    relatedTo: "Madre",
    summary: "Póliza de decesos al día.",
    due_date: "2027-02-01",
    due_label: "Próximo recibo: 1 de febrero de 2027",
    amount: 240,
    previous_amount: 240,
    insights: [
      { type: "detected", text: "Recibo anual de 240 € previsto para el 01/02/2027." },
      { type: "recommendation", text: "Todo correcto. Guardado en el archivo de tu madre." },
    ],
    steps: ["No se requiere ninguna acción por ahora."],
    reminders: [],
    history: [
      { date_label: "1 feb 2025", text: "Póliza de decesos registrada." },
    ],
    actions: ["Ver detalle"],
    documents: [],
  },

  // ---- Asuntos de MASCOTAS (fluyen a Inicio y Próximos como cualquier asunto) ----
  {
    id: "pet-luna-rabies",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    pet_id: "pet-luna",
    petName: "Luna",
    title: "Vacuna antirrábica",
    category: "Mascotas",
    matter_type: "Vacuna",
    status: STATUS.ATTENTION,
    priority: "alta",
    icon: "Syringe",
    provider: "Clínica Veterinaria El Prado",
    relatedTo: "Luna (perro)",
    summary: "La vacuna antirrábica de Luna está a punto de caducar.",
    due_date: "2026-10-09",
    due_label: "Caduca el 9 de octubre de 2026 (en 4 días)",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "La vacuna antirrábica de Luna caduca el 09/10/2026." },
      { type: "verify", text: "Comprueba con tu veterinario y, si vas a viajar, verifica los requisitos del destino." },
      { type: "verify", text: "Confirma con tu veterinario si toca recordatorio anual o si la pauta de Luna es distinta." },
    ],
    steps: [
      "Llamar a la clínica para pedir cita de vacunación.",
      "Llevar la cartilla/pasaporte de Luna.",
      "Anotar la nueva fecha de caducidad al vacunar.",
    ],
    reminders: [
      { date_label: "6 de octubre de 2026", status: "Programado", text: "Pedir cita para la vacuna antirrábica" },
    ],
    history: [
      { date_label: "9 oct 2025", text: "Vacuna antirrábica administrada (validez 1 año)." },
    ],
    actions: ["Ver opciones", "Recordármelo"],
    documents: ["doc-luna-cartilla"],
  },
  {
    id: "pet-luna-vet",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    pet_id: "pet-luna",
    petName: "Luna",
    title: "Revisión veterinaria anual",
    category: "Mascotas",
    matter_type: "Cita veterinaria",
    status: STATUS.UPCOMING,
    priority: "media",
    icon: "Stethoscope",
    provider: "Clínica Veterinaria El Prado",
    relatedTo: "Luna (perro)",
    summary: "Chequeo general anual de Luna.",
    due_date: "2026-10-12",
    due_label: "12 de octubre de 2026 · 11:00 h",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Cita de revisión anual el 12/10/2026 a las 11:00 en la Clínica El Prado." },
      { type: "verify", text: "Si el veterinario te indicó algo concreto para esta revisión, tenlo a mano." },
    ],
    steps: ["Preparar la cartilla de Luna.", "Acudir a la cita el día señalado."],
    reminders: [
      { date_label: "11 de octubre de 2026", status: "Programado", text: "Recordatorio: revisión de Luna mañana" },
    ],
    history: [
      { date_label: "10 oct 2025", text: "Revisión anterior: estado general bueno." },
    ],
    actions: ["Ver cita", "Preparar cita", "Recordármelo"],
    documents: [],
  },
  {
    id: "pet-luna-deworm",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    pet_id: "pet-luna",
    petName: "Luna",
    title: "Desparasitación trimestral",
    category: "Mascotas",
    matter_type: "Desparasitación",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Bug",
    provider: "Clínica Veterinaria El Prado",
    relatedTo: "Luna (perro)",
    summary: "Pauta de desparasitación al día.",
    due_date: "2026-12-01",
    due_label: "Próxima dosis: 1 de diciembre de 2026",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Próxima desparasitación prevista para el 01/12/2026." },
      { type: "recommendation", text: "Todo correcto. Te avisaré cuando se acerque la fecha." },
    ],
    steps: ["No se requiere ninguna acción por ahora."],
    reminders: [
      { date_label: "25 de noviembre de 2026", status: "Programado", text: "Aviso: desparasitar a Luna" },
    ],
    history: [
      { date_label: "1 sep 2026", text: "Desparasitación interna realizada." },
    ],
    actions: ["Ver detalle"],
    documents: [],
  },
  {
    id: "pet-luna-insurance",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    pet_id: "pet-luna",
    petName: "Luna",
    title: "Seguro de mascota",
    category: "Mascotas",
    matter_type: "Seguro",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "ShieldCheck",
    provider: "Mapfre Mascotas",
    relatedTo: "Luna (perro)",
    summary: "Seguro de responsabilidad civil y veterinario al día.",
    due_date: "2027-01-15",
    due_label: "Próxima renovación: 15 de enero de 2027",
    amount: 180,
    previous_amount: 172,
    insights: [
      { type: "detected", text: "Renovación del seguro el 15/01/2027 por 180 €." },
      { type: "recommendation", text: "Sin acciones por ahora. Revisaré coberturas antes de renovar." },
    ],
    steps: ["No se requiere ninguna acción por ahora."],
    reminders: [],
    history: [
      { date_label: "15 ene 2025", text: "Póliza de mascota contratada (172 €)." },
    ],
    actions: ["Ver detalle"],
    documents: ["doc-luna-seguro"],
  },
  {
    id: "pet-luna-passport",
    user_id: "user-demo-1",
    family_member_id: "fm-self",
    person: "Ángel",
    pet_id: "pet-luna",
    petName: "Luna",
    title: "Pasaporte y documentación",
    category: "Mascotas",
    matter_type: "Documentación",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "BookMarked",
    provider: "—",
    relatedTo: "Luna (perro)",
    summary: "Pasaporte europeo y microchip registrados.",
    due_date: "2030-05-01",
    due_label: "Pasaporte vigente · microchip registrado",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Pasaporte europeo y número de microchip guardados en el archivo." },
      { type: "recommendation", text: "Documentación en regla. Nada que hacer por ahora." },
    ],
    steps: ["No se requiere ninguna acción."],
    reminders: [],
    history: [
      { date_label: "5 may 2020", text: "Pasaporte europeo emitido." },
    ],
    actions: ["Ver detalle"],
    documents: ["doc-luna-cartilla"],
  },
  {
    id: "pet-rocky-med",
    user_id: "user-demo-1",
    family_member_id: "fm-partner",
    person: "Pareja (Carmen)",
    pet_id: "pet-rocky",
    petName: "Rocky",
    title: "Medicación periódica (tiroides)",
    category: "Mascotas",
    matter_type: "Medicación",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Pill",
    provider: "Clínica Veterinaria El Prado",
    relatedTo: "Rocky (gato)",
    summary: "Tratamiento diario para el tiroides de Rocky.",
    due_date: "2026-10-28",
    due_label: "Reponer medicación: 28 de octubre de 2026",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Rocky toma medicación diaria; próxima reposición el 28/10/2026." },
      { type: "recommendation", text: "Conviene no quedarse sin dosis. Te avisaré unos días antes." },
      { type: "verify", text: "La pauta y la dosis las indica tu veterinario; no las modifiques sin consultarle." },
    ],
    steps: ["Comprobar las dosis restantes.", "Pedir receta/reposición con antelación."],
    reminders: [
      { date_label: "24 de octubre de 2026", status: "Programado", text: "Aviso: reponer medicación de Rocky" },
    ],
    history: [
      { date_label: "1 oct 2026", text: "Última reposición de medicación." },
    ],
    actions: ["Ver detalle", "Recordármelo"],
    documents: [],
  },
  {
    id: "pet-rocky-checkup",
    user_id: "user-demo-1",
    family_member_id: "fm-partner",
    person: "Pareja (Carmen)",
    pet_id: "pet-rocky",
    petName: "Rocky",
    title: "Próxima revisión de control",
    category: "Mascotas",
    matter_type: "Cita veterinaria",
    status: STATUS.UPCOMING,
    priority: "media",
    icon: "Stethoscope",
    provider: "Clínica Veterinaria El Prado",
    relatedTo: "Rocky (gato)",
    summary: "Control de tiroides y analítica de Rocky.",
    due_date: "2026-11-05",
    due_label: "5 de noviembre de 2026 · 17:30 h",
    amount: null,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Revisión de control el 05/11/2026 a las 17:30." },
      { type: "verify", text: "Confirma con la clínica si debes aportar algún resultado o informe previo." },
    ],
    steps: ["Confirmar la cita con la clínica.", "Preparar solo lo que te indique la clínica."],
    reminders: [
      { date_label: "4 de noviembre de 2026", status: "Programado", text: "Recordatorio: revisión de Rocky" },
    ],
    history: [
      { date_label: "5 may 2026", text: "Analítica de control dentro de rango." },
    ],
    actions: ["Ver cita", "Preparar cita", "Recordármelo"],
    documents: [],
  },
  {
    id: "pet-rocky-invoice",
    user_id: "user-demo-1",
    family_member_id: "fm-partner",
    person: "Pareja (Carmen)",
    pet_id: "pet-rocky",
    petName: "Rocky",
    title: "Factura veterinaria",
    category: "Mascotas",
    matter_type: "Gasto / Factura",
    status: STATUS.CONTROLLED,
    priority: "baja",
    icon: "Receipt",
    provider: "Clínica Veterinaria El Prado",
    relatedTo: "Rocky (gato)",
    summary: "Factura de la última consulta, pagada.",
    due_date: "2026-09-18",
    due_label: "Pagada el 18 de septiembre de 2026",
    amount: 64,
    previous_amount: null,
    insights: [
      { type: "detected", text: "Factura de 64 € por consulta y analítica, pagada el 18/09/2026." },
      { type: "recommendation", text: "Guardada en el archivo de Rocky por si la necesitas para el seguro." },
    ],
    steps: ["No se requiere ninguna acción."],
    reminders: [],
    history: [
      { date_label: "18 sep 2026", text: "Factura recibida y archivada (64 €)." },
    ],
    actions: ["Ver detalle"],
    documents: ["doc-rocky-factura"],
  },
];

export const getMatterById = (id) => MATTERS.find((m) => m.id === id);

// documents: repositorio de soporte
export const DOCUMENTS = [
  {
    id: "doc-car-policy",
    user_id: "user-demo-1",
    matter_id: "car-insurance",
    filename: "Póliza seguro coche 2026.pdf",
    type: "PDF",
    category: "Vehículos",
    size: "1,2 MB",
    created_at: "2025-10-20",
    date_label: "20 oct 2025",
  },
  {
    id: "doc-home-policy",
    user_id: "user-demo-1",
    matter_id: "home-insurance",
    filename: "Póliza hogar.pdf",
    type: "PDF",
    category: "Hogar",
    size: "980 KB",
    created_at: "2025-03-01",
    date_label: "1 mar 2025",
  },
  {
    id: "doc-ibi",
    user_id: "user-demo-1",
    matter_id: "home-ibi",
    filename: "Recibo IBI 2026.jpg",
    type: "Imagen",
    category: "Hogar",
    size: "420 KB",
    created_at: "2026-09-10",
    date_label: "10 sep 2026",
  },
  {
    id: "doc-luna-cartilla",
    user_id: "user-demo-1",
    matter_id: "pet-luna-rabies",
    pet_id: "pet-luna",
    filename: "Cartilla y pasaporte Luna.pdf",
    type: "PDF",
    category: "Mascotas",
    size: "1,1 MB",
    created_at: "2025-10-09",
    date_label: "9 oct 2025",
  },
  {
    id: "doc-luna-seguro",
    user_id: "user-demo-1",
    matter_id: "pet-luna-insurance",
    pet_id: "pet-luna",
    filename: "Póliza seguro Luna 2026.pdf",
    type: "PDF",
    category: "Mascotas",
    size: "760 KB",
    created_at: "2025-01-15",
    date_label: "15 ene 2025",
  },
  {
    id: "doc-rocky-factura",
    user_id: "user-demo-1",
    matter_id: "pet-rocky-invoice",
    pet_id: "pet-rocky",
    filename: "Factura veterinaria Rocky.pdf",
    type: "PDF",
    category: "Mascotas",
    size: "320 KB",
    created_at: "2026-09-18",
    date_label: "18 sep 2026",
  },
];

export const getDocumentsForMatter = (matter) =>
  DOCUMENTS.filter((d) => (matter?.documents || []).includes(d.id));

export const CATEGORIES = [
  { id: "viviendas", label: "Viviendas", icon: "Building2", match: "__viviendas__" },
  { id: "vehiculos", label: "Vehículos", icon: "Car", match: "__vehiculos__" },
  { id: "ocio", label: "Ocio y Reservas", icon: "Ticket", match: "Ocio" },
  { id: "contratos", label: "Contratos y servicios personales", icon: "FileSignature", match: "Contratos y seguros" },
  { id: "familia", label: "Familia", icon: "Users", match: "__familia__" },
  { id: "mascotas", label: "Mascotas", icon: "PawPrint", match: "Mascotas" },
];

// Nombre visible de una categoría interna (el valor guardado se mantiene).
export const CONTRATOS_KEY = "Contratos y seguros";
export const catLabel = (c) => (c === CONTRATOS_KEY ? "Contratos y servicios personales" : c || "Otros");

export const getCategoryById = (id) => CATEGORIES.find((c) => c.id === id);

// Cuenta de asuntos por área (basada en MATTERS para coincidir con la vista filtrada)
export const getCategoryCount = (cat) => {
  if (cat.id === "familia") {
    return MATTERS.filter((m) => m.family_member_id !== "fm-self").length;
  }
  return MATTERS.filter((m) => m.category === cat.match).length;
};

// Perfiles de familia (FASE 1: sin permisos ni invitaciones reales)
export const getMattersByMember = (fmId) =>
  MATTERS.filter((m) => m.family_member_id === fmId);

export const getStatusSummary = (matters) => ({
  attention: matters.filter((m) => m.status === STATUS.ATTENTION).length,
  upcoming: matters.filter((m) => m.status === STATUS.UPCOMING).length,
  controlled: matters.filter((m) => m.status === STATUS.CONTROLLED).length,
});

// mascotas: pertenecen al núcleo familiar. Modelo preparado para el futuro:
// { id, id_usuario(user_id), id_familia(family_id), nombre(name), especie(species),
//   raza(breed), fecha_nacimiento(birth_date), numero_microchip(microchip),
//   aseguradora(insurer), veterinario_habitual(vet), notas(notes) }
export const PETS = [
  {
    id: "pet-luna",
    user_id: "user-demo-1",
    family_id: "family-demo-1",
    owner_member_id: "fm-self",
    name: "Luna",
    species: "Perro",
    breed: "Labrador",
    birth_date: "2020-03-14",
    age_label: "6 años",
    microchip: "941000012345678",
    insurer: "Mapfre Mascotas",
    vet: "Clínica Veterinaria El Prado",
    icon: "Dog",
    notes: "Alérgica al pollo. Peso de referencia: 28 kg.",
  },
  {
    id: "pet-rocky",
    user_id: "user-demo-1",
    family_id: "family-demo-1",
    owner_member_id: "fm-partner",
    name: "Rocky",
    species: "Gato",
    breed: "Europeo común",
    birth_date: "2018-07-02",
    age_label: "8 años",
    microchip: "941000098765432",
    insurer: "Sin seguro",
    vet: "Clínica Veterinaria El Prado",
    icon: "Cat",
    notes: "Tratamiento diario de tiroides. Revisión semestral.",
  },
];

export const getPetById = (id) => PETS.find((p) => p.id === id);
export const getMattersByPet = (petId) => MATTERS.filter((m) => m.pet_id === petId);
export const getDocumentsForPet = (petId) => DOCUMENTS.filter((d) => d.pet_id === petId);

export const getMemberById = (id) => CURRENT_USER.family_members.find((m) => m.id === id);

// Fecha de referencia para la demo (para cálculos de "próximos")
export const TODAY_DEMO = "2026-10-05";

// Conjunto de datos de demostración para migrar a la cuenta real del usuario demo.
export const DEMO = {
  asuntos: MATTERS,
  mascotas: PETS,
  familiares: CURRENT_USER.family_members.map((m) => ({
    id: m.id, name: m.name, relation: m.relation, es_titular: m.id === "fm-self",
  })),
  documentos: DOCUMENTS,
};
